module.exports = __webpack_public_path__ + "img/download_code.4bd14647.png";